import Vue from 'vue';
import treasuryKids from './treasury-kids/treasury-kids.vue';
import store from '../common/js/vuex/store';
import treasuryKidsModule from './treasury-kids/treasury-kids-vuex';
if (!store.hasModule(['treasuryKids'])) {
	store.registerModule('treasuryKids', treasuryKidsModule);
}
Vue.component('treasury-kids', treasuryKids);
